import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const DeliversCreate = props => (
  <Create {...props} resource="delivers">
    <Form />
  </Create>
);

DeliversCreate.propTypes = {};

export default DeliversCreate;
